
const LIFERAY_HOST = 'https://lab.diginfactory.com';
export const REACT_APP_LIFERAY_HOST     = window?.Liferay?.ThemeDisplay?.getPortalURL() || LIFERAY_HOST;
export const REACT_APP_OAUTH_CLIENT_ID     = process.env.REACT_APP_OAUTH_CLIENT_ID     || 'id-caabae90-a784-4081-6f24-2e4ebcb68447';
export const REACT_APP_OAUTH_CLIENT_SECRET = process.env.REACT_APP_OAUTH_CLIENT_SECRET || 'secret-735bf6b1-d84f-445f-13ca-e6299b47ac8';